module.exports = __webpack_public_path__ + "img/step17_b_tear_the_plastic.72f593fa.png";